import { IErrorResponse } from "@carm/_utils/models";

export interface IAlert {
  alertTypeUid?: AlertType;
  title?: string;
  content?: string;
  containerPageUid?: string;
}

export enum AlertType {
  Info= 'INFO',
  Success= 'SUCCESS',
  Warning = 'WARNING',
  Attention = 'ATTENTION',
}

export interface IAlertsResponse extends IErrorResponse
{
  alerts: IAlert[];
}
